import React from "react";
import { FaComments, FaCode, FaRocket } from "react-icons/fa";
import "./Partnership.css";

const steps = [
  {
    icon: FaComments,
    num: "01",
    title: "Echange initial",
    desc: "On discute de votre projet gratuitement. On comprend vos besoins, votre budget et vos delais avant de vous proposer quoi que ce soit.",
  },
  {
    icon: FaCode,
    num: "02",
    title: "Developpement",
    desc: "On construit votre solution de A a Z. Vous suivez l'avancement en temps reel et validez chaque etape avant la livraison.",
  },
  {
    icon: FaRocket,
    num: "03",
    title: "Livraison & suivi",
    desc: "On deploie, on vous forme et on reste disponibles apres la mise en ligne. Votre succes digital ne s'arrete pas au lancement.",
  },
];

export default function Partnership() {
  return (
    <section className="partnership">
      <h2>Notre methode</h2>
      <p className="partnership-subtitle">
        Un processus simple et transparent, du premier contact a la mise en ligne.
      </p>
      <div className="partnership-steps">
        {steps.map((s) => {
          const Icon = s.icon;
          return (
            <div className="partnership-step" key={s.num}>
              <div className="partnership-step-icon">
                <Icon size={28} />
              </div>
              <span className="partnership-step-num">{s.num}</span>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
